import { SITE_CONFIG } from '../config';

const COMM_URL = 'https://tophamtechbe.com/api/treas/comm';
const headers = { 'X-API-Key': 'treas-api-key-2025' };
export const SENDER_WARNING_EVENT = 'aw:sender-warning';
export const SENDER_STATUS_EVENT = 'aw:sender-status-changed';

// Keep the original Response intact for existing callers. Never retry a send here.
export async function sendEmailRequest(url, options = {}) {
  if (options.body instanceof FormData) {
    options.body.set('site_id', SITE_CONFIG.SITE_ID);
    options.body.set('responseFormat', 'json');
  }
  const response = await fetch(url, options);
  let data = null;
  if (response.headers.get('content-type')?.includes('application/json')) {
    try { data = await response.clone().json(); } catch { /* Delivery status still comes from HTTP. */ }
  }
  const warningCode = data?.warningCode || response.headers.get('X-Email-Warning-Code');
  if (warningCode) {
    const sentCount = data?.sentCount ?? Number(response.headers.get('X-Email-Sent-Count') || 0);
    const fallbackUsed = data?.fallbackUsed ?? (response.headers.get('X-Email-Fallback-Used') === 'true');
    const delivered = fallbackUsed && (response.ok || sentCount > 0);
    window.dispatchEvent(new CustomEvent(SENDER_WARNING_EVENT, { detail: {
      warningCode,
      message: delivered
        ? (response.ok ? 'Email sent using the default sender. ' : 'Some emails were sent using the default sender. ')
          + 'Your custom sender needs attention. Update and verify it in Email Manager.'
        : 'Email delivery failed and your custom sender needs attention. Check delivery status before resending.'
    } }));
  }
  window.dispatchEvent(new Event(SENDER_STATUS_EVENT));
  return response;
}

export async function getSenderWarnings(signal) {
  const response = await fetch(`${COMM_URL}/sender-status?site_id=${encodeURIComponent(SITE_CONFIG.SITE_ID)}`, {
    headers, cache: 'no-store', signal
  });
  if (!response.ok) throw new Error('Sender status is temporarily unavailable.');
  const data = await response.json();
  if (!Array.isArray(data.warnings)) throw new Error('Sender status is temporarily unavailable.');
  return data.warnings;
}

export async function verifySavedSender() {
  const body = new URLSearchParams({ site_id: SITE_CONFIG.SITE_ID });
  const response = await fetch(`${COMM_URL}/verify-sender`, { method: 'POST', headers, body });
  let data;
  try { data = await response.json(); } catch { throw new Error('Sender verification is temporarily unavailable.'); }
  window.dispatchEvent(new Event(SENDER_STATUS_EVENT));
  if (!response.ok || !data.verified) throw new Error(data.message || 'Your sender could not be verified.');
  return data;
}
